"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.yellowBackground = exports.warning = exports.textExtra = exports.text = exports.success = exports.secondary = exports.redBackground = exports.purpleBackground = exports.primary = exports.pinkBackground = exports.oriGrey = exports.offer = exports.lightItem = exports.inputElements = exports.info = exports.greenBackground = exports.error = exports.defaultColors = exports.commonColors = exports.brownBackground = exports.blueGreyBackground = exports.blueBackground = exports.background = exports.action = void 0;
const defaultColors = exports.defaultColors = {
  light: '#999999',
  main: '#333333',
  dark: '#111111',
  contrastText: '#ffffff'
};
const error = exports.error = {
  light: '#ffe8e8',
  main: '#c60d22',
  dark: '#930000',
  contrastText: '#ffffff'
};
const info = exports.info = {
  light: '#e9f1f7',
  main: '#2774ae',
  dark: '#003da5',
  contrastText: '#ffffff'
};

// this is added for setting color for input elements
const inputElements = exports.inputElements = {
  light: '#9cdabc',
  main: '#227c66',
  dark: '#111111',
  contrastText: '#ffffff'
};
const offer = exports.offer = {
  light: '#f8d8cc',
  main: '#da3a00',
  dark: '#9c2700',
  contrastText: '#ffffff'
};
const primary = exports.primary = {
  light: '#e1f4eb',
  main: '#9cdabc',
  dark: '#227c66',
  contrastText: '#333333'
};
const secondary = exports.secondary = {
  light: '#80cdd0',
  main: '#007681',
  dark: '#00575f',
  contrastText: '#ffffff'
};
const success = exports.success = {
  light: '#95e0c9',
  main: '#32a58e',
  dark: '#00725B',
  contrastText: '#ffffff'
};
const warning = exports.warning = {
  light: '#fff8db',
  main: '#ffda5e',
  dark: '#ffcd00',
  contrastText: '#333333'
};
const text = exports.text = {
  primary: '#333333',
  secondary: '#555555',
  active: '#227c66',
  disabled: '#aaaaaa',
  hover: '#227c66'
};
const textExtra = exports.textExtra = {
  heading: '#555555',
  contrast: '#777777'
};
const action = exports.action = {
  disabledBackground: 'rgba(0, 0, 0, 0.12)',
  disabled: 'rgba(0, 0, 0, 0.26)'
};
const commonColors = exports.commonColors = {
  white: '#ffffff',
  black: '#000000'
};
const background = exports.background = {
  paper: '#ffffff',
  default: '#ffffff'
};
const blueBackground = exports.blueBackground = {
  50: '#ceebef',
  100: '#7ed1ea',
  200: '#749fc7',
  300: '#2774ae',
  400: '#003da5'
};
const blueGreyBackground = exports.blueGreyBackground = {
  50: '#d0d0ce',
  100: '#a7a8aa',
  200: '#888888',
  300: '#63666a',
  400: '#000000'
};
const brownBackground = exports.brownBackground = {
  50: '#d7d2cb',
  100: '#b6ada5',
  200: '#a59c94',
  300: '#857874',
  400: '#5e514d'
};
const greenBackground = exports.greenBackground = {
  50: '#e1f4eb',
  100: '#91e7e3',
  200: '#80cdd0',
  300: '#00b7bd',
  400: '#007681'
};
const pinkBackground = exports.pinkBackground = {
  50: '#f5dadf',
  100: '#e793b7',
  200: '#d47d99',
  300: '#cf578a',
  400: '#c800a1'
};
const purpleBackground = exports.purpleBackground = {
  50: '#e0d2e7',
  100: '#b2afef',
  200: '#898cc3',
  300: '#685bc7',
  400: '#4a25aa'
};
const redBackground = exports.redBackground = {
  50: '#ffb3aa',
  100: '#c36d6a',
  200: '#ff8072',
  300: '#e40046',
  400: '#9b2743'
};
const yellowBackground = exports.yellowBackground = {
  50: '#f8e59a',
  100: '#f0c264',
  200: '#ffda5e',
  300: '#ffcd00',
  400: '#eb3300'
};
const oriGrey = exports.oriGrey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#e5e5e5',
  300: '#cccccc',
  400: '#bbbbbb',
  500: '#888888',
  600: '#777777',
  700: '#555555',
  800: '#444444',
  900: '#333333',
  A100: '#f0f0f0',
  A200: '#dddddd',
  A400: '#999999',
  A700: '#666666',
  A900: '#2a2a2a'
};
const lightItem = exports.lightItem = {
  default: {
    background: '#f5f5f5',
    textAlert: '#333333',
    textTag: '#333333'
  },
  error: {
    background: '#ffe8e8',
    textAlert: '#870614',
    textTag: '#333333'
  },
  info: {
    background: '#e9f1f7',
    textAlert: '#003dA5',
    textTag: '#333333'
  },
  offer: {
    background: '#f8d8cc',
    textAlert: '#333333',
    textTag: '#9c2700'
  },
  primary: {
    background: '#e1f4eb',
    textAlert: '#333333',
    textTag: '#333333'
  },
  secondary: {
    background: '#ceebef',
    textAlert: '#333333',
    textTag: '#333333'
  },
  success: {
    background: '#eaf8f3',
    textAlert: '#00725B',
    textTag: '#333333'
  },
  warning: {
    background: '#fff8db',
    textAlert: '#333333',
    textTag: '#333333'
  }
};
